import { Flex, VisuallyHidden } from '@chakra-ui/react';
import { Radio } from '@morressier/alembic';
import { ChangeEventHandler } from 'react';
import { Control, Controller } from 'react-hook-form';

type IValue = string | boolean;

interface RadioGroupProps {
  name: string;
  control: Control<any>;
  options: {
    value: IValue;
    children: React.ReactNode;
  }[];
  defaultValue?: IValue;
  required?: boolean;
  gap?: number;
  isEditingAllowed?: boolean;
}

export const StandardReportingGuidelinesRadioGroup = (
  props: RadioGroupProps
) => {
  const { isEditingAllowed = true } = props;
  return (
    <Controller
      name={props.name}
      control={props.control}
      defaultValue={props.defaultValue ?? null}
      rules={{ required: props.required ? 'This field is required.' : false }}
      render={({ field: { onChange, value } }) => (
        <Flex flexDirection="column" gap={props.gap ?? 0}>
          {props.options.map(option => {
            const id = `${props.name}-${option.value}`;
            return (
              <Flex flexDirection="row">
                <Radio
                  name={props.name}
                  id={id}
                  value={option.value}
                  onChange={
                    (() =>
                      onChange(
                        option.value
                      )) as ChangeEventHandler<HTMLInputElement>
                  }
                  checked={value === option.value}
                  ariaLabel={`${props.name}-${option.value}`}
                  // @ts-ignore
                  disabled={!isEditingAllowed}
                >
                  <VisuallyHidden>{option.children}</VisuallyHidden>
                </Radio>
                <Flex flex="1" flexDirection="column">
                  {option.children}
                </Flex>
              </Flex>
            );
          })}
        </Flex>
      )}
    />
  );
};
